
import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { observer } from "mobx-react";
import toastMessagesListStore from "./toast-messages-store";
import ToastMessage from "./toast-message/toast-message";
import './toast-messages-modal.scss';


const ToastMessagesModal: React.FC = observer(() => {
    const el = useRef(document.createElement('div'));
    const parentElement = document.body;

    useEffect(() => {
        parentElement.appendChild(el.current);
        const elem = el.current;
        return () => {
            elem?.parentNode?.removeChild(elem);
        }
    }, [parentElement])

    return createPortal(
        (
            <div className="toast-messages-modal">
                {toastMessagesListStore.list.map((toast, index) => (
                    <ToastMessage key={index} toast={toast} />
                ))}
            </div>
        ),
        el.current
    );
});

export default ToastMessagesModal;